export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00065.ddcc3552.png";